/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Ws message type dto
 */
export interface WsMessageTypeDto {
  wsMessageType?: WsMessageTypeDto.WsMessageTypeEnum;
}
export namespace WsMessageTypeDto {
  export const WsMessageTypeEnum = {
    Error: 'error',
    Balance: 'balance',
    Trades: 'trades',
    Positions: 'positions',
    HouseSpecificPositions: 'house-specific-positions',
  } as const;
  export type WsMessageTypeEnum = (typeof WsMessageTypeEnum)[keyof typeof WsMessageTypeEnum];
}
